import { RiseOutlined, TagOutlined, PercentageOutlined, InboxOutlined, ScissorOutlined } from '@ant-design/icons';
import { VibrantModuleCard } from './common/ModuleCard';
import { HomeStyledCardWrapper } from './common/AlertAndNotificationCard';

const modules = [
    {
        icon: RiseOutlined,
        title: 'Category Growth',
        description: 'Sales drivers, consumption trends, base & incremental analysis',
        color: '270 65% 55%',
        path: '/promo/category-diagnostics/growth-analysis',
    },
    {
        icon: TagOutlined,
        title: 'Strategic Pricing',
        description: 'Price simulations, price ladder, price curve & elasticity analysis',
        color: '45 95% 55%',
        path: '/pricing/recommendation/price-change',
    },
    {
        icon: PercentageOutlined,
        title: 'Promo Excellence',
        description: 'Promo optimization, bump reports, ROI analysis & investment tracking',
        color: '205 65% 52%',
        path: '/promo/analytics/promo-score-card',
    },
    {
        icon: InboxOutlined,
        title: 'Price Pack Architecture',
        description: 'PPA simulations, white space analysis & pack architecture planning',
        color: '160 55% 48%',
        path: '/pricing/analytics/price-point',
    },
    {
        icon: ScissorOutlined,
        title: 'Assortment & Mix',
        description: 'Mix simulations, GM vs volume growth & distribution opportunities',
        color: '330 65% 52%',
        path: '/assortment/pvm-analysis',
    },
];

export const VibrantPlanningEngineSection = () => {
    return (
        <HomeStyledCardWrapper bordered={false}>
            <h3 className="text-lg font-semibold text-gray-800 mb-6 m-0">
                AI Intelligence Studio{' '}
                <span className="text-sm text-gray-500 font-normal">— Self-serve analytics & exploration</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                {modules.map((module, index) => (
                    <VibrantModuleCard key={index} {...module} />
                ))}
            </div>
        </HomeStyledCardWrapper>
    );
};
